import { List } from '@mui/material';
import { FC } from 'react';
import { Connection } from '@/types/connection';
import FixedListItem from './FixedListItem';

type FixedListProps = {
  id: number;
  connections: Connection[];
  onArrowClick: (data: Connection[]) => void;
  updateAddConnection: (newConnection: Connection) => void;
};

const FixedList: FC<FixedListProps> = (props) => {
  return (
    <List subheader='Fixed Connections' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {props.connections.map((connection, index) => {
        return (
          <FixedListItem
            key={`${connection.action}.${index}`}
            action={connection.action}
            label={connection.label}
            data={props.connections}
            index={index}
            onArrowClick={props.onArrowClick}
            onChange={(label) => {
              props.updateAddConnection({ ...connection, label: label });
            }}
          />
        );
      })}
    </List>
  );
};

export default FixedList;
